import Button from '@atoms/Button/Button';
import Text from '@atoms/Text/Text';
import { IArticleListingLinkCard } from '@models/IArticleListingLinkCard';

const ArticleListingLinkCard = ({
  text,
  title,
  trumpetText,
  cta,
}: IArticleListingLinkCard) => (
  <article className="tw-flex tw-h-full tw-flex-col tw-bg-blue tw-px-6 tw-py-8 md:tw-px-8">
    <Text variant="label-12" className="tw-mb-2 tw-uppercase tw-text-grey-30">
      {trumpetText}
    </Text>
    <Text variant="heading-32" className="tw-mb-4 tw-text-white lg:tw-hidden">
      {title}
    </Text>
    <Text
      variant="heading-40"
      className="tw-mb-6 tw-text-white max-lg:tw-hidden"
      as="p"
    >
      {title}
    </Text>
    <Text variant="body" className="tw-text-grey-30">
      {text}
    </Text>
    <div className="tw-mt-auto">
      <Button
        buttonClasses="tw-mt-20"
        as="link"
        key={text}
        modifier="fill"
        href={cta.url}
        target={cta.target}
        label={cta.text}
      />
    </div>
  </article>
);

export default ArticleListingLinkCard;
